"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingBoneStyleName = exports.ShineStyleName = exports.getShineColor = exports.getBackgroundColor = exports.ShineAnimationDurationMs = exports.shineWidth = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
exports.shineWidth = 80;
exports.ShineAnimationDurationMs = 1600;
var getBackgroundColor = function (alpha) {
    if (alpha === void 0) { alpha = 1; }
    return "var(--loading-bone-background-color, rgba(230, 230, 230, " + alpha + "))";
}; // #e6e6e6
exports.getBackgroundColor = getBackgroundColor;
var getShineColor = function (alpha) {
    if (alpha === void 0) { alpha = 1; }
    return "var(--loading-bone-shine-color, rgba(245, 245, 245, " + alpha + "))";
}; // #f5f5f5
exports.getShineColor = getShineColor;
exports.ShineStyleName = TypeStyle.style({
    $nest: {
        '@media (prefers-reduced-motion: no-preference)': {
            animationDuration: exports.ShineAnimationDurationMs + "ms",
            animationTimingFunction: 'linear',
            animationIterationCount: 'infinite',
            height: '100%',
            position: 'absolute',
        }
    }
});
var LoadingBoneBaseStyleName = TypeStyle.style({
    backgroundColor: exports.getBackgroundColor(1),
    borderRadius: "var(--loading-bone-border-radius, 2px)",
    height: '1rem',
    overflow: 'hidden',
    position: 'relative',
});
exports.LoadingBoneStyleName = LoadingBoneBaseStyleName + " " + TypeStyle.style({
    $nest: (_a = {},
        _a["& + ." + LoadingBoneBaseStyleName] = {
            marginTop: 8,
            $nest: {
                '&:nth-child(even)': {
                    width: '70%'
                },
            }
        },
        _a)
});
//# sourceMappingURL=SkeletonLoaderStyles.js.map